export const fieldNameBankAccountId = 'bankAccountId';

export const skeletonBankAccountCount = 3;
